import * as z from 'zod'
import type { ZodTypeAny } from 'zod'

/*
    As long as unified_legal_comfort_3_basic_roland_de and legal_basis_3_basic_roland_de use
 the same conversions for data it makes sense to check this from here
 */
export const getLegalSchemaWithPreprocess = (schema: ZodTypeAny) => {
  return z.preprocess((values) => {
    const valuesCopy = { ...(values as Record<string, any>) }

    const {
      legal_insurance_in_last_5y,
      number_of_claims_in_last_5y,
      partner_coverage_type,
      partner_first_name,
      partner_last_name,
      previous_insurer,
      number_of_years_claims_free,
    } = valuesCopy

    return {
      ...valuesCopy,
      number_of_claims_in_last_5y: legal_insurance_in_last_5y ? number_of_claims_in_last_5y : 0,
      partner_first_name: partner_coverage_type !== 'single' ? partner_first_name : undefined,
      partner_last_name: partner_coverage_type !== 'single' ? partner_last_name : undefined,
      previous_insurer: legal_insurance_in_last_5y ? previous_insurer : undefined,
      number_of_years_claims_free: legal_insurance_in_last_5y ? number_of_years_claims_free : 0,
    }
  }, schema)
}
